import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sso-logout',
  templateUrl: './sso-logout.component.html',
  styleUrls: ['./sso-logout.component.scss']
})
export class SsoLogoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
